// Turbo must be loaded first
import { Turbo } from '@hotwired/turbo-rails'
Turbo.session.drive = false // Disable Turbo by default

// jQuery must be loaded first before loading other files or jQuery-based packages
// Some packages, like 'bootbox', depend on the global variables of jQuery (window.$, window.jQuery)
import '../functions/loadJquery'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { ApolloProvider } from '@apollo/client/react'
import 'bootstrap'
import { Modal } from 'bootstrap'

import client from '../functions/client'
import legacy from '../functions/legacy' // rely on the 'bootstrap' package
import parseProps from '../functions/parseProps'
import animateStores from '../functions/animateStores'
import initImageGallery from '../functions/imageGallery'
import Calculator from '../containers/Calculator'
import ColorInput from '../components/ColorInput'

import '@client-side-validations/client-side-validations'
import '@client-side-validations/simple-form/dist/simple-form.bootstrap4.esm'
import '../functions/accessibleFormErrors'

import 'cocoon-js-vanilla'
import 'animate.css'

import '../functions/bootstrap'
import '../controllers' // Stimulus controllers
import '../functions/bootstrap-datepickers'

document.addEventListener('DOMContentLoaded', () => {
  // All our legacy with 👹 globals
  legacy()

  // Initialize image gallery (photoswipe)
  initImageGallery()

  // Animations on the front page
  if (
    document.body.classList.contains('index') &&
    document.body.id === 'welcome'
  ) {
    animateStores()
  }

  // Color pickers for Tags
  const targetColorPickerContainer = document.getElementById(
    'anchor-pack-color-picker'
  )
  if (targetColorPickerContainer) {
    const targetColorPickerRoot = createRoot(targetColorPickerContainer)
    const props = parseProps(targetColorPickerContainer)

    targetColorPickerRoot.render(<ColorInput {...props} />)
  }

  // Shipping Calculator
  const targetCalculatorContainer = document.getElementById(
    'anchor-pack-calculator'
  )
  if (targetCalculatorContainer) {
    const targetCalculatorRoot = createRoot(targetCalculatorContainer)

    targetCalculatorRoot.render(
      <ApolloProvider client={client}>
        <Calculator />
      </ApolloProvider>
    )
  }

  // Bootstrap 5 notification popup trigger
  const modalEl = document.getElementById('user_broadcast_notification_popup')
  if (modalEl) {
    const modal = new Modal(modalEl, {
      backdrop: 'static',
      keyboard: false,
    })
    modal.show()
  }
})
